import BasicResource from '@/api/resource';

class subscriptionResource extends BasicResource {
    constructor () {
        super('subscription');
    }

    cancel () {
        return this.client.request({
            method: 'PUT',
            path:   '/upyield/v1/subscription/cancel',
        });
    }

    revoke () {
        return this.client.request({
            method: 'PUT',
            path:   '/upyield/v1/subscription/revoke',
        });
    }

    changeCreditCard (stripeTokenId) {
        return this.client.request({
            method: 'PUT',
            path:   `/upyield/v1/${this.resourceName}/payment`,
            data: { 'stripe_source': stripeTokenId },
        });
    }

    info (params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/info`,
            params: params,
        });
    }

    chart (params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/chart`,
            params: params,
        });
    }
}

export default new subscriptionResource;
